export default __webpack_public_path__ + "static/media/logo4.a54e3a86.svg";